import { createStore } from 'vuex'
import authApi from "../api/auth";
import options from "./modules/options";
import user from "./modules/user";
import bbsPackage from "./modules/packages";
import stores from "./modules/stores";
import bank from "./modules/bank";
import importPackage from "./modules/import";
import supports from "./modules/supports";
import userApi from "../api/user";

const state = {
    userId: "",
    locale: localStorage.getItem('language') || "vi",
    userInfo:null,
    phone:""
};
//root getter
const getters = {};

// root action
const actions = {
    async login({}, payload) {
        const {data} = await authApi.login(payload);
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
    },

    async register({}, payload) {
        const {data} = await authApi.register(payload);
    },

    async logout() {
        await authApi.logout();
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
    },
    async getUserProfile({ commit }) {
        const { data } = await userApi.getUserInfo(`?include=photo,default_store,shop`);
        if (![`shop_admin`].includes(data?.data?.role_name)) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            window.location.href = '/login';
        }
        commit('SET_LOCALE', data?.data?.locale);
        commit('SET_USER_INFO', data?.data);
        commit('SET_USER_ID', data?.data?.id || "");
        commit('SET_PHONE', data?.data.phone || "");
    },
    async setLocale({ commit }, payload){
        commit('SET_LOCALE', payload);
        localStorage.setItem('language', payload);
    }
};

// root mutation
const mutations = {
    SET_LOCALE: (state, payload) => state.locale = payload,
    SET_USER_ID: (state, payload) => state.userId = payload,
    SET_PHONE: (state, payload) => state.phone = payload,
    SET_USER_INFO: (state, payload) => state.userInfo = payload, 
};

const store = createStore({
    strict: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        user: user,
        options: options,
        stores: stores,
        bank: bank,
        packages: bbsPackage,
        imports: importPackage,
        supports: supports,
    }
});

export default store;